import React, { useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import TestimonialPropTwo from "../component/testimonial/TestimonialPropTwo";
import TestimonialData from "../data/testimonial/TestimonialData.json";
import { slugify } from "../utils";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BreadCrumbTestimonials from "../elements/breadcrumb/BreadCrumbTestimonials";
import CounterUpOne from "../component/counterup/CounterUpOne";
import ClientSlider from "../component/client/ClientSlider";

const allData = TestimonialData;

const Testimonials = () => {
  const [sliderRef, setSliderRef] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const navigationStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  };

  const headerContainerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px'
  };

  const titleContainerStyles = {
    flex: '1'
  };

  const sliderStyles = {
    marginTop: '30px'
  };

  const slideItemStyles = {
    padding: '0 15px'
  };

  const buttonStyles = {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    background: 'transparent',
    border: '1px solid #e5e5e5',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      background: '#562b7a',
      borderColor: '#562b7a',
      color: '#ffffff'
    }
  };

  // Create separate styles for hover state using styled-components approach
  const SliderButton = ({ children, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    const combinedStyles = {
      ...buttonStyles,
      ...(isHovered ? {
        background: '#562b7a',
        // borderColor: '#562b7a',
        color: '#ffffff'
      } : {})
    };

    return (
      <button 
        style={combinedStyles}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}
      </button>
    );
  };

  return (
    <>
        <SEO title="Testimonials" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbTestimonials title="Testimonials" subtitle="" page="Testimonials" />

        <div className="section section-padding customer-review-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <SectionTitle
                  subtitle="Feedback That Drives Us: Insights from Our Satisfied Clients "
                  title="Google Reviews"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
              </div>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-8">
                    <div className="review-site-logo">
                      <a href="https://www.google.com/">
                        {/* <img
                          src={process.env.PUBLIC_URL + "/images/icon/google.png"}
                          alt="Google"
                        /> */}
                      </a>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={navigationStyles}>
                      <SliderButton onClick={() => sliderRef?.slickPrev()}>
                        ←
                      </SliderButton>
                      <SliderButton onClick={() => sliderRef?.slickNext()}>
                        →
                      </SliderButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div style={sliderStyles}>
                  <Slider ref={setSliderRef} {...settings}>
                    {allData.map((testimonial) => (
                      <div key={testimonial.id} style={slideItemStyles}>
                        <TestimonialPropTwo
                          testimonialData={[testimonial]}
                          colSize="col-lg-12"
                          itemShow="1"
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CounterUpOne />
        <div className="container "style={{paddingTop:'100px'}} >
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35" 
          parentClass="your-custom-class"
        />
        <AboutThree />
        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Testimonials;